const isClient = typeof document !== 'undefined';

function readElementById(id) {
  return isClient
    ? JSON.parse(document.getElementById(id).textContent)
    : {};
}

export let relay = readElementById('relayData');
export let store = readElementById('storeData');
export let config = readElementById('configData');

if (config && config.graphql_url && config.graphql_url.endsWith('/')) {
  config.graphql_url = config.graphql_url.slice(0, -1);
}

__webpack_public_path__ = config.static_root;



// WEBPACK FOOTER //
// ../src/client/config.js